var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCathodicProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C5.55228 0 6 0.447716 6 1V3.58696C6 4.36736 5.36737 5 4.58694 5H3.11111C2.49747 5 2 5.49746 2 6.11111V15C2 15.5523 2.44772 16 3 16H13C13.5523 16 14 15.5523 14 15V6.11111C14 5.49746 13.5025 5 12.8889 5H11.4131C10.6326 5 10 4.36736 10 3.58696V1C10 0.447716 10.4477 0 11 0C11.5523 0 12 0.447716 12 1V3H14C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H2C0.895416 18 0 17.1046 0 16V5C0 3.89543 0.895416 3 2 3H4V1C4 0.447716 4.44772 0 5 0ZM9 5L8.20001 9H10L7 15L7.83334 10H6L7 5H9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCathodicProtection);
export default __webpack_public_path__ + "static/media/cathodicProtection.e47d43f7.svg";
export { ForwardRef as ReactComponent };